module.exports = __webpack_public_path__ + "assets/img/Interior.986152c2.jpg";